// Fixme Critical class constructor 开始判断类型相同则直接返回导致无法创建新的相同对象

class SpavaObj {
  creationTime = ''
  lastUpdateTime = ''
  creator = ''
  lastEditor = ''

  constructor (o) {
    if (o instanceof Object) {
      this.id = o.id || ''
      this.creationTime = o.creationTime || ''
      this.lastUpdateTime = o.lastUpdateTime || ''
      this.creator = o.creator || ''
      this.lastEditor = o.lastEditor || ''
    }
  }

  equal (o) {
    if (o instanceof Object) {
      return o.id === this.id
    }
    return false
  }

  static fromAPI (o) {
    return new SpavaObj(o)
  }

  static getObjKey (value, constructor, config = {}) {
    if (config.array) {
      if (value instanceof Array) {
        return value.map(v => v instanceof constructor ? v : new constructor(v))
      }
      else return []
    }
    if (value instanceof constructor) {
      return value
    }
    else if (value) {
      return new constructor(value)
    }
    else {
      if (config.fill) {
        return new constructor()
      }
      return null
    }
  }
}

class Image {
  // static READY = '0'
  // static LOADING = '1'
  // static ERROR = '-1'
  // static SUCCESS = '2'
  src = null
  url = ''
  error = false
  errorMessage = ''
  loading = false
  percent = 0

  constructor (o) {
    if (o instanceof Object) {
      this.src = o.src || null
      this.error = o.error || false
      this.url = o.url || ''
      this.errorMessage = o.errorMessage || ''
      this.percent = o.percent || 0
      this.loading = o.loading || false
    }
  }

  get isError () {
    return this.error
  }

  get isSuccess () {
    return this.src && this.url
  }

  get isReady () {
    return this.url && !this.src
  }

  get isLoading () {
    return this.loading
  }
}

export {
  SpavaObj,
  Image
}
